export const FLIGHT_TRIP_TYPE_LABELS = Object.freeze({
  round_trip: 'Return',
  return: 'Return',
  one_way_outbound: 'One Way Out',
  one_way_out: 'One Way Out',
  one_way_inbound: 'One Way In',
  one_way_in: 'One Way In',
  unknown: 'Unknown',
});

const ONE_WAY_OUTBOUND_TRIP_TYPES = new Set([
  'one_way_outbound',
  'one_way_out',
]);

export const isOneWayOutboundTrip = (tripType) => (
  ONE_WAY_OUTBOUND_TRIP_TYPES.has(String(tripType || '').trim().toLowerCase())
);

/**
 * Common Singapore-corridor airports for flight-ticket comboboxes.
 * Free typing remains allowed — OCR and uncommon airports are never blocked.
 * Labels keep the City (IATA) pattern; Trichy includes both official and
 * everyday names so HR and workers find TRZ the way they say it.
 */
export const AIRPORT_SUGGESTIONS = Object.freeze([
  'Singapore (SIN)',
  'Kuala Lumpur (KUL)',
  'Penang (PEN)',
  'Jakarta (CGK)',
  'Medan (KNO)',
  'Bangkok (BKK)',
  'Manila (MNL)',
  'Cebu (CEB)',
  'Ho Chi Minh City (SGN)',
  'Hanoi (HAN)',
  'Yangon (RGN)',
  'Dhaka (DAC)',
  'Chattogram (CGP)',
  'Sylhet (ZYL)',
  'Chennai (MAA)',
  'Tiruchirappalli / Trichy (TRZ)',
  'Madurai (IXM)',
  'Coimbatore (CJB)',
  'Kochi (COK)',
  'Thiruvananthapuram (TRV)',
  'Bengaluru (BLR)',
  'Hyderabad (HYD)',
  'Kolkata (CCU)',
  'Mumbai (BOM)',
  'Delhi (DEL)',
  'Colombo (CMB)',
  'Kathmandu (KTM)',
  'Hong Kong (HKG)',
  'Guangzhou (CAN)',
  'Shenzhen (SZX)',
  'Taipei (TPE)',
  'Seoul (ICN)',
  'Tokyo (NRT)',
  'Phnom Penh (PNH)',
]);
